<ng-container *ngIf="!(isBoutiqueClosed$|async) || (isBoutiqueClosed$|async) && (boutiqueClosedMode$|async) === 'normal'">

  <ng-container *ngIf="variation; else noDataTemplate">

    <ng-container *ngIf="(snipcartService.snipcart$|async);else cartLoadingTemplate">
      <ng-container [ngSwitch]="true">

        <ng-template *ngSwitchCase="hasMoreVariants && cartQuantity !== -1"
                     [ngTemplateOutlet]="hasMoreVariantsTemplate">
        </ng-template>

        <ng-template *ngSwitchCase="cartQuantity === -1"
                     [ngTemplateOutlet]="noStockTemplate">
        </ng-template>

        <ng-template *ngSwitchCase="cartQuantity === 0 && hasMoreVariants === false"
                     [ngTemplateOutlet]="addToCartTemplate">
        </ng-template>

        <ng-template *ngSwitchCase="cartQuantity > 0 && !hasMoreVariants"
                     [ngTemplateOutlet]="quantityTemplate">
        </ng-template>

      </ng-container>
    </ng-container>

  </ng-container>

</ng-container>

<ng-container *ngIf="(isBoutiqueClosed$|async) && (boutiqueClosedMode$|async) === 'unavailable'">

  <ng-template [ngTemplateOutlet]="noStockTemplate">
  </ng-template>

</ng-container>

<ng-template #noDataTemplate>

  <div class="no-data-group">
  </div>

</ng-template>

<ng-template #noStockTemplate>

  <div class="no-stock-group text-center">
    <ng-container *transloco="let t">
      <span class="text-uppercase font-weight-bold" [innerHTML]="t('unavailable')"></span>
    </ng-container>
  </div>

</ng-template>

<ng-template #hasMoreVariantsTemplate>

  <button
    [class.pointer-event-none]="true"
    mat-flat-button
    class="quantity-container-size text-uppercase buy-btn">

    <ng-container *ngIf="(quantityService.loading$|async) === false">
      <ng-container *transloco="let t">
        <span class="label" [innerHTML]="t('choose')"></span>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="(quantityService.loading$|async) === true">
      <div class="d-flex flex-fill align-items-center justify-content-center">
        <mat-spinner diameter="15"></mat-spinner>
      </div>
    </ng-container>

  </button>

</ng-template>

<ng-template #addToCartTemplate>
  <button
    [class.pointer-event-none]="(quantityService.loading$|async) === true"
    (click)="add()"
    mat-flat-button
    class="quantity-container-size text-uppercase buy-btn">

    <ng-container *ngIf="(quantityService.loading$|async) === false">
      <ng-container *transloco="let t">
        <span class="label" [innerHTML]="t('buy')"></span>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="(quantityService.loading$|async) === true">
      <div class="d-flex flex-fill align-items-center justify-content-center">
        <mat-spinner diameter="15"></mat-spinner>
      </div>
    </ng-container>

  </button>

</ng-template>

<ng-template #quantityTemplate>

  <div
    class="quantity-container-size add-to-cart-group d-flex align-items-center justify-content-between position-relative">

    <button
        #removeButton
        (click)="remove()"
        mat-icon-button
        color="accent"
        [class.pointer-event-none]="(quantityService.loading$|async) === true"
        class="quantity-module add-to-cart-btn remove position-relative">
      <mat-icon svgIcon="icon-variant-remove"></mat-icon>
    </button>

    <div class="quantity-module d-flex align-items-center justify-content-center user-select-none">
      <span class="quantity text-center" [innerHTML]="internalQuantity"></span>
    </div>

    <ng-container *ngIf="(quantityService.loading$|async) === true">
      <div
        class="position-absolute top-0 left-0 w-100 h-100 quantity-module d-flex align-items-center justify-content-center pointer-event-none">
        <mat-spinner diameter="26" color="accent" strokeWidth="1"></mat-spinner>
      </div>
    </ng-container>

    <button
        #addButton
        (click)="add()"
        mat-icon-button
        [class.pointer-event-none]="(quantityService.loading$|async) === true"
        color="accent"
        class="quantity-module add-to-cart-btn add">
      <mat-icon svgIcon="icon-variant-add"></mat-icon>
    </button>

  </div>

</ng-template>

<ng-template #cartLoadingTemplate>
  <ng-container *ngIf="!(scullyRunning$|async)">
    <div class="quantity-module d-flex align-items-center justify-content-center">
      <mat-spinner diameter="15" color="accent"></mat-spinner>
    </div>
  </ng-container>
</ng-template>
